import { BreedType } from 'shared/@types';
import { PurebredBadge } from 'shared/components/purebred-badge';
import type { BreedNameProps } from 'shared/components/breed-name.types';

export function BreedName({ name, badgeClassName, ...badgeProps }: BreedNameProps) {
  if (badgeProps.breedType !== BreedType.Purebred) return <>{name}</>;

  const lastSpace = name.lastIndexOf(' ');

  return (
    <>
      {name.slice(0, lastSpace + 1)}
      <span className="whitespace-nowrap">
        {name.slice(lastSpace + 1)}
        {'\u00a0'}
        <PurebredBadge {...badgeProps} className={badgeClassName} />
      </span>
    </>
  );
}
